import React from 'react'
import PropTypes from 'prop-types'

import Styles from './index.scss'
import Item from './Item'

const TabPitchSummary = props => (
  <section className={`section-tab ${Styles['section-pitch-summary']}`}>
    <div className={`${Styles['filter-box']}`}>
      <span className={`${Styles['filter-item']}`}>Status Filter:</span>
      {props.optionStatus.map(optionStatus => (
        <div className={`${Styles['filter-item']}`} key={optionStatus.value}>
          <input
            type="radio"
            name="status"
            value={optionStatus.value}
            checked={props.filterStatus === optionStatus.value}
            onChange={props.getDataPitchSummary(props.filterStatus, props.projectDetail.id)}
          /> {optionStatus.label}
        </div>
      ))}
    </div>
    <div className={`${Styles['pitch-container']}`}>
      {props.pitchSummary.rows.map((data, index) => (
        <Item key={data.id} {...data} index={index} />
      ))}
    </div>
  </section>
)

TabPitchSummary.propTypes = {
  pitchSummary: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  optionStatus: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default TabPitchSummary
